import * as tmpServicesSDK from '@tmp-services/sdk';

// clients
export import AuthZClient = tmpServicesSDK.CareerServiceModule.AuthZClient;
export import CareerClient = tmpServicesSDK.CareerServiceModule.UserPreferencesClient;
export import CareerServiceConfigClient = tmpServicesSDK.CareerServiceModule.CareerServiceConfigClient;

//notification types
export import Notification = tmpServicesSDK.CareerServiceModule.Notification;
export import CareerServiceConfiguration = tmpServicesSDK.CareerServiceModule.CareerServiceConfiguration;

// bookmark types
export import UserPreferences = tmpServicesSDK.CareerServiceModule.UserPreferences;
export import EntityType = tmpServicesSDK.CareerServiceModule.EntityType;
export interface IBookmark {
  id: string;
  type: 'Role' | 'Discipline';
  /** True to add, false to remove */
  isActive: boolean;
}

/** Values for a CDP's goal: "Excel in role", "Shift career", etc. */
export enum Goal {
  /** No goal set, used when value is unknown */
  None = 'None',
  /** Do well in the current role without plans to change roles */
  ExcelInRole = 'ExcelInRole',
  /** e.g. as an IC2, acquire skills of an IC3, or M4 to M5 */
  PrepareForNextCareerStage = 'PrepareForNextCareerStage',
  /** Change to a different discipline, e.g. SWE to PM */
  ShiftCareer = 'ShiftCareer',
  /** Keep the same role, but in a different business area, e.g. HR Engineering to Azure */
  MoveInternally = 'MoveInternally',
  /** Probably deprecated, but preserving to match current UI */
  OtherHelp = 'OtherHelp',
}
